import axios from "axios";
import { get as _get, forEach as _forEach } from "lodash";

import { handleFault, FAIL } from "./errorUtils";

export const executeRequest = (request, faultLabel) => {
    return axios(request)
        .then((response) => {
            checkResponseForError(response);
            return response;
        })
        .catch((err) => {
            throw handleFault(err, faultLabel);
        });
};

export const executeGet = (url, faultLabel, params) => {
    return axios
        .get(url, { ...params, withCredentials: true })
        .then((response) => {
            checkResponseForError(response);
            return response;
        })
        .catch((err) => {
            throw handleFault(err, faultLabel);
        });
};

export const executeGetAll = (urls, faultLabel) => {
    return axios
        .all(urls)
        .then(
            axios.spread((...responses) => {
                _forEach(responses, (response) => {
                    checkResponseForError(response);
                });
                return responses;
            })
        )
        .catch((err) => {
            throw handleFault(err, faultLabel);
        });
};

const checkResponseForError = (response) => {
    if (!_get(response, "data") || _get(response, "data.status") === FAIL) {
        throw response;
    }
};
